module.exports = __webpack_public_path__ + "static/media/GalleryMain15.1962503b.jpg";